import { model, models, Schema, Types, Model } from "mongoose";

export interface INativePrice {
  chainId: number;
  value: string;
  time: Date;
}

const NativePriceSchema = new Schema(
  {
    chainId: {
      type: Number,
      required: true,
    },
    value: {
      type: Schema.Types.Decimal128,
      default: new Types.Decimal128("0"),
    },
    time: {
      type: Date,
      default: Date.now,
    },
  },
  {
    toObject: {
      getters: true,
      versionKey: false,
      transform: (doc, ret: any) => {
        ret.id = ret._id.toString();
        delete ret._id;

        ret.value = ret.value.toString();
        return ret;
      },
    },
  }
);

NativePriceSchema.index({ chainId: 1, time: 1 }, { unique: true });

export const NativePriceModel: Model<any> =
  models?.NativePrice || model("NativePrice", NativePriceSchema);

export default NativePriceModel;
